import { createContext } from "react";

import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import api from "../app/api";
import { DeleteAlert, UpdateAlert } from "../components/Swal Alert/index";
import useAlert from "./useAlert";

import { capitalFirstLetter } from "../config/functions";
import {
  addChecklist,
  deleteChecklist,
  setChecklist,
  updateChecklist,
} from "../features/checklist/slice";

const ChecklistContext = createContext();

function ChecklistState(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const favourite = location?.search.split("?favourite=")[1];
  const { collection } = useSelector((state) => state.checklist);
  const { categories } = useSelector((state) => state.category);

  const { showAlert } = useAlert();

  // STATES
  const [questionTypes, setQuestionTypes] = useState();
  const [loading, setLoading] = useState();
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);

  // New Checklist State
  const [data, setData] = useState({
    title: "",
    checklistReport: "None",
    checklistFrequency: "Daily",
    notificationFrequency: {
      times: [Date.now()],
      date: Date.now(),
      day: "",
    },
    reportFrequency: {
      times: [Date.now()],
      date: Date.now(),
      day: "",
    },
    questions: [],
    categoryID: categories[0]?._id,
  });
  const [question, setQuestion] = useState({
    question: "",
    type: "",
    hintText: "",
    options: [],
    yes: "",
    no: "",
    required: false,
  });
  const onDublicateQuestiuon = (question, index) => {
    var questions = [...data.questions];
    if (index == undefined) {
      questions.push(question);
    } else {
      questions = [
        ...questions.slice(0, index + 1),
        question,
        ...questions.slice(index + 1),
      ];
    }

    setData({ ...data, questions });
  };
  const fetchChecklists = async (params) => {
    setLoading("fetch");
    try {
      const response = await api.get(`/checklist`, { params });
      dispatch(setChecklist(response.data));

      setLoading(false);
    } catch (err) {
      const message = err.response
        ? err.response.data?.message
          ? err.response.data?.message
          : err.response.data
        : err;
      showAlert(capitalFirstLetter(message), "danger");
      setLoading(false);
    }
  };
  const fetchChecklistByCompanyId = async (id) => {
    setLoading(true);
    try {
      if (!id) return setLoading(false);
      const response = await api.get(`/checklist/${id}`);
      dispatch(setChecklist(response.data));
      setLoading(false);
    } catch (err) {
      const message = err.response
        ? err.response.data?.message
          ? err.response.data?.message
          : err.response.data
        : err;
      setLoading(false);
      showAlert(capitalFirstLetter(message), "danger");
    }
  };
  const fetchQuestionTypes = async () => {
    setLoading(true);
    try {
      const response = await api.get("/checklist/question/types");
      setQuestionTypes(response.data.questionTypes);
      setLoading(false);
    } catch (err) {
      const message = err.response
        ? err.response.data?.message
          ? err.response.data?.message
          : err.response.data
        : err;
      showAlert(capitalFirstLetter(message), "danger");
      setLoading(false);
    }
  };

  const onAddQuestiuon = (
    e,
    sortIndex,
    setSortIndex,
    editIndex,
    setEditIndex
  ) => {
    e.preventDefault();
    var questions = [...data.questions];
    if (question.type == "Smart Threshold") {
      if (question.emails?.length < 1 || !question.emails) {
        showAlert("Please select email for Smart Threshold question", "danger")
        return
      }
      if (question.threshold?.length < 1 || !question.threshold) {
        showAlert("Please add threshold for Smart Threshold question", "danger")
        return
      }
    }
    if (editIndex || editIndex == 0) {
      questions.splice(editIndex, 1);
      setEditIndex(undefined);
    }
    if (sortIndex) {
      questions.splice(sortIndex - 1, 0, question);
      setSortIndex(questions.length + 1);
    } else {
      questions.push(question);
    }
    setData({ ...data, questions });
    setQuestion({
      question: "",
      type: "",
      hintText: "",
      options: [],
      yes: "",
      no: "",
      required: false,
    });
  };

  const newChecklist = async () => {
    setLoading("new");
    try {
      console.log(data)
      const response = await api.post("/checklist/new", { ...data });

      dispatch(addChecklist(response.data));
      setLoading(false);
      setData({
        title: "",
        checklistFrequency: "Daily",
        checklistFrequency: "Daily",
        notificationFrequency: "",
        questions: [],
        category: categories[0],
      });
      showAlert("New checklist added ", "success");
      navigate("/checklists");
    } catch (err) {
      const message = err.response
        ? err.response.data?.message
          ? err.response.data?.message
          : err.response.data
        : err;
      showAlert(capitalFirstLetter(message), "danger");
      setLoading(false);
    }
  };
  const changeChecklist = async (status) => {
    if (!(await UpdateAlert())) return;
    setLoading(status ? status : "update");
    try {
      await api.put(
        `/checklist/update/${data._id}`,
        status ? { status } : data
      );
      setData({ ...data, status });
      dispatch(updateChecklist({ ...data, status }));
      setLoading(false);
      showAlert(
        status
          ? `Checklist review: ${status}`
          : "Checklist updated successfully",
        "success"
      );
      return true;
    } catch (err) {
      const message = err.response
        ? err.response.data?.message
          ? err.response.data?.message
          : err.response.data
        : err;
      setLoading(false);
      showAlert(capitalFirstLetter(message), "danger");
      setLoading(false);
    }
  };
  const toggleFavourite = async (checklistID, isFavourite) => {
    try {
      let response = await api.post("/checklist/toggleFavourite", { checklistID, isFavourite });
      if (!favourite) {
        dispatch(updateChecklist(response.data));
        if (isFavourite) {
          showAlert("Checklist added to favourites", "success");
        } else {
          showAlert("Checklist removed from favourites", "success");
        }
      } else {
        dispatch(deleteChecklist(response.data));
        showAlert("Checklist removed from favourites", "success");
      }

    } catch (err) {
      const message = err.response
        ? err.response.data?.message
          ? err.response.data?.message
          : err.response.data
        : err;
      showAlert(message, "danger");
    }
  }
  const removeChecklist = async (checklist) => {
    if (!(await DeleteAlert())) return;
    setLoading("delete");
    try {
      const response = await api.delete(
        `/checklist/delete/${checklist ? checklist._id : data._id}`
      );
      dispatch(deleteChecklist(response.data));
      setLoading(false);
      if (!checklist) navigate("/checklists");
      showAlert("Checklist removed successfully", "success");
    } catch (err) {
      const message = err.response
        ? err.response.data?.message
          ? err.response.data?.message
          : err.response.data
        : err;
      showAlert(message, "danger");
      setLoading(false);
    }
  };

  // Review
  const sendForReview = async () => {
    changeChecklist("pending");
  };
  const approveReview = async () => {
    const allow = await changeChecklist("approved");
    if (allow) newChecklist();
  };
  const rejectReview = async () => {
    changeChecklist("rejected");
  };
  return (
    <ChecklistContext.Provider
      value={{
        categories,
        collection,
        page,
        limit,
        loading,
        data,
        question,
        questionTypes,
        setData,
        setQuestion,
        fetchChecklists,
        fetchChecklistByCompanyId,
        fetchQuestionTypes,
        setPage,
        onAddQuestiuon,
        newChecklist,
        changeChecklist,
        removeChecklist,
        sendForReview,
        approveReview,
        rejectReview,
        onDublicateQuestiuon,
        setLimit,
        toggleFavourite
      }}
    >
      {props.children}
    </ChecklistContext.Provider>
  );
}
export { ChecklistContext, ChecklistState };
